/**
 * Platform-aware path utilities
 */

export const isWindows = () => {
    if (typeof navigator !== 'undefined') {
        return navigator.userAgent.includes('Windows');
    }
    if (typeof process !== 'undefined') {
        return process.platform === 'win32';
    }
    return false;
};

export const getSeparator = () => (isWindows() ? '\\' : '/');

export const joinPaths = (...parts: string[]) => {
    const separator = getSeparator();
    return parts
        .map((part, index) => {
            if (index === 0) return part.replace(/[/\\]+$/, '');
            return part.replace(/^[/\\]+|[/\\]+$/g, '');
        })
        .filter(part => part.length > 0)
        .join(separator);
};

export const sanitizeFilename = (filename: string) => {
    return filename.replace(/[^a-z0-9]/gi, '_').toLowerCase();
};
